import React, { useEffect } from 'react';
import { useField } from 'formik';
import styles from "layout/Auth/Auth.module.scss";
import { getRemainingWords } from "helpers/common";
import SpeechToTextButton from "./SpeechToTextButton";
import useSpeechToTextField from "./useSpeechToTextField";

const AppInputField = ({ fieldType, label, wordLimit, onInputChange, characterLimit, speechToText = false, speechToTextOptions = {}, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const speechHandlers = useSpeechToTextField(field.value, setValue, speechToTextOptions);

  useEffect(() => {
    let value = typeof field?.value == "string" ? field?.value?.trimLeft() : field.value;

    if (fieldType == "number" && typeof field?.value == "string") {
      if (field.name == 'price' && fieldType == "number") {
        value = value.replace(/[^0-9.]/g, "");
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts[1];
        }
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + "." + parts[1].substring(0, 2);
        }
      }
      else {
        value = value?.replace(/\D/g, "");
      }
    }

    setValue(value);
    typeof onInputChange == "function" && onInputChange(value);
  }, [setValue, field.value]);

  return (
    <>
      {fieldType === "textarea" ? (
        <textarea
          {...field}
          {...props}
        ></textarea>
      ) : (
        <input
          {...field}
          {...props}
        />
      )}
     <div className="mt-2 mx-0">
       {speechToText && (
        <SpeechToTextButton
          {...speechToTextOptions}
          {...speechHandlers}
        />
      )}
     </div>
      <div className="d-flex justify-content-between">
        <div className="error">
          {meta.touched && meta.error}
        </div>
        {
          characterLimit && (
            <div style={{ textAlign: "right" }}>
              <small className={`text-${field?.value?.length >= characterLimit ? "danger" : "muted"}`}>
                {field?.value?.length || 0}/{characterLimit}
              </small>
            </div>
          )
        }
        {wordLimit && (
          <p className="m-0">
            Maximum {wordLimit} Words {" "}
            ({getRemainingWords(field?.value, wordLimit)} Remaining)
          </p>
        )}
      </div>
    </>
  );
};

export default AppInputField;
